<template>
    <LayoutSub className="company_content location">
        <SubSection class="pb-0">
            <h2>본사</h2>
            <div class="infor_row">
                <div class="infor_unit">
                    <span class="title">Address.</span>
                    <span class="content">서울시 중구 세종대로 39 대한상공회의소 7층</span>
                </div>
                <div class="infor_unit">
                    <span class="title">Tel.</span>
                    <span class="content"><a href="tel:1600-1234">1600-1234</a></span>
                </div>
            </div>
            <div class="infor_row">
                <div class="infor_unit">
                    <span class="title">Subway.</span>
                    <span class="content">
                        <div class="tag_unit">
                            <span class="bedge line-1">1호선</span>
                            <div class="content">서울역 3번 출구 YTN방향 5분 거리</div>
                        </div>
                        <div class="tag_unit">
                            <span class="bedge line-2">2호선</span>
                            <div class="content">시청역 9번 출구 삼성본관방향 5분 거리</div>
                        </div>
                        <div class="tag_unit">
                            <span class="bedge line-4">4호선</span>
                            <div class="content">회현역 5번 출구 숭례문방향 5분 거리</div>
                        </div>
                    </span>
                </div>
            </div>
            <div class="map_box">
                <!-- <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.7620035996665!2d126.97118897662179!3d37.56067067204014!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c9ef6e911c355%3A0x463209545ca94e04!2z64yA7ZWc7IOB6rO17ZqM7J2Y7IaM!5e0!3m2!1sko!2skr!4v1733817425349!5m2!1sko!2skr"
                    style="border: 0" allowfullscreen="" loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"></iframe> -->
                <img src="@/assets/map_main.png" alt="" />
            </div>
        </SubSection>
        <SubSection class="pb-0">
            <h2>데이터센터</h2>
            <div class="infor_row">
                <div class="infor_unit">
                    <span class="title">Address.</span>
                    <span class="content">서울시 금천구 가산디지털1로 189 LG가산디지털센터 7층</span>
                </div>
                <div class="infor_unit">
                    <span class="title">Tel.</span>
                    <span class="content"><a href="tel:1600-1234">1600-1234</a></span>
                </div>
            </div>
            <div class="infor_row">
                <div class="infor_unit">
                    <span class="title">Subway.</span>
                    <span class="content">
                        <div class="tag_unit">
                            <span class="bedge line-1">1호선</span>
                            <div class="content">가산디지털단지역 7번 출구 5분 거리</div>
                        </div>
                        <div class="tag_unit">
                            <span class="bedge line-7">7호선</span>
                            <div class="content">가산디지털단지역 6번 출구 5분 거리</div>
                        </div>
                    </span>
                </div>
            </div>
            <div class="map_box">
                <!-- <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6332.688371357629!2d126.87723294778422!3d37.47620348824838!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b61e2a7e4c019%3A0x345e2f3a749fe5dc!2zTEfqsIDsgrDrlJTsp4DthLjshLzthLA!5e0!3m2!1sko!2skr!4v1733817551961!5m2!1sko!2skr"
                    style="border: 0" allowfullscreen="" loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"></iframe> -->
                <img src="@/assets/map_data_center.png" alt="" />
            </div>
        </SubSection>
    </LayoutSub>
</template>
<script>
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubSection,
    },
};
</script>
<style lang="scss" scoped></style>
